// صفحات Nfts.js
import { useState, useEffect } from 'react';
import {
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Typography,
  IconButton,
  Box,
  Stack,
  Button
} from '@mui/material';
import { ChevronLeft, ChevronRight, Edit, Add } from '@mui/icons-material';
import MLoading from "components/MLoading";

import NftFormModal from 'components/NftFormModal';
import { getNfts, createNft, updateNft } from 'api/getApi';

function Nfts() {
  const [data, setData] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingNft, setEditingNft] = useState(null);
  const [mode, setMode] = useState('add'); // 'add' یا 'edit'

  const columns = [
    { id: 'name', label: 'Name', width: '25%' },
    { id: 'link', label: 'Link', width: '25%' },
    { id: 'description', label: 'Description', width: '25%' },
    { id: 'action', label: 'Action', width: '25%' },
  ];

  const getDashboard = async (page) => {
    try {
      setLoading(true);
      const response = await getNfts(page);
      setData(response.data);
      setPagination({
        current_page: response.current_page,
        last_page: response.last_page,
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashboard(pagination.current_page);
  }, [pagination.current_page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setPagination(prev => ({...prev, current_page: newPage}));
    }
  };

  const handleOpenModal = (nft = null) => {
    if (nft) {
      setEditingNft(nft);
      setMode('edit');
    } else {
      setEditingNft(null);
      setMode('add');
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingNft(null);
  };

  const handleSubmit = async (formData) => {
    try {
      if (mode === 'add') {
        await createNft(formData);
      } else {
        await updateNft(formData);
      }
      // پس از افزودن یا ویرایش، داده‌ها را مجدداً بارگیری کنید
      getDashboard(pagination.current_page);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  if (loading || !data) return <MLoading />;

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  List NFTS
                </MDTypography>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Add />}
                  onClick={() => handleOpenModal()}
                >
                  Add NFT
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <Box sx={{ width: '100%', overflow: 'hidden' }}>
                  <TableContainer sx={{ width: '100%' }}>
                    <Table sx={{ width: '100%' }}>
                      <TableHead style={{width:"100%",display:"table-caption"}}>
                        <TableRow sx={{
                          display:"flex",
                          width: '100%', 
                          m: 0,          
                          p: 0         
                        }}>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              sx={{ 
                                width: column.width,
                                bgcolor: 'background.default',
                                borderBottom: '2px solid',
                                borderColor: 'divider'
                              }}
                            >
                              <Typography variant="subtitle1" fontWeight={600}>
                                {column.label}
                              </Typography>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {data.length > 0 ? (
                          data.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell sx={{ width: '25%', borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2">
                                  {row.name || '-'}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ width: '25%', borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2">
                                  {row.link || '-'}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ width: '25%', borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2">
                                  {row.description || '-'}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ width: '25%', borderBottom: '1px solid', borderColor: 'divider' }}>
                                <IconButton 
                                  color="primary"
                                  onClick={() => handleOpenModal(row)}
                                >
                                  <Edit />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4} sx={{ textAlign: 'center', py: 4 }}>
                              <Typography variant="body2" color="text.secondary">
                                No data available
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Pagination بدون تغییر */}
                </Box>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <NftFormModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        initialData={editingNft}
        mode={mode}
      />
    </DashboardLayout>
  );
}

export default Nfts;